import TicketSelection from '../components/TicketSelection';
import Header from '../components/Header';

const Tickets = () => {
    return (
        <>
            <Header />
            <TicketSelection />
        </>
    );
}

export default Tickets;
